// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './vuetify'; 
import 'vuetify/dist/vuetify.min.css';
import router from './router'; 
import '@mdi/font/css/materialdesignicons.css';
import './styles.css';

// Importar la directiva
import swipeLeftDirective from './directives/swipeLeft'; // Asegúrate de que la ruta sea correcta
import tapDirective from './directives/swipeTap'; // Asegúrate de que la ruta sea correcta

const app = createApp(App);

// Registrar la directiva globalmente
app.directive('swipe-left', swipeLeftDirective);
app.directive('swipe-tap', tapDirective);

// Montar la aplicación
app.use(router)  // Usa el router aquí
  .use(vuetify)
  .mount('#app');
